import { X } from 'lucide-react';
import { type ReactElement, useState } from 'react';

/** HOME 맨 위 한 줄 공지 — 흑연 띠에 라임 글자. 닫으면 이 화면을 떠날 때까지 숨긴다. */
export const SiteHeaderAnnouncement = (): ReactElement | null => {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="relative bg-primary px-10 py-2 text-center text-xs text-primary-foreground sm:text-[13px]">
      <p>기업·단체 굿즈, 상담 후 확정견적으로 주문마다 제작합니다</p>
      <button
        type="button"
        onClick={() => setIsOpen(false)}
        aria-label="공지 닫기"
        className="absolute top-1/2 right-3 flex size-6 -translate-y-1/2 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring sm:right-5"
      >
        <X aria-hidden className="size-3.5" />
      </button>
    </div>
  );
};
